
import { useUserContext } from "../../../../contexts/user-context/UserContext";
import { useQueryNotifications } from "../../../../queries/UseQueryNotifications";
import { useGroup } from "../../../../queries/groups/UseGroup";
import { useEffect, useRef, useState } from "react";
import { GraphOptions } from "../../../../services/trending-data-service/Models";
import NoData from "../../../no-data/NoData";
import { useTranslation } from "react-i18next";
import Graph, { GraphType } from "../../../graph/Graph";
import { DashboardContainer, DashboardContainerType } from "../../../dashboard/dashboard-container/DashboardContainer";
import { useAlarmNotificationCounts } from "../../../../queries/alarm-data/UseAlarmNotificationCounts";
import NotificationsCountsGraphUtils from "./NotificationsCountsGraphUtils";
import { differenceInDays } from "date-fns";

export type NotificationsCountsGraphProps = {
    groupID: number,
    startDate: Date,
    endDate: Date,
    showEmail: boolean,
    showVoice: boolean,
    showText: boolean
};


export function NotificationsCountsGraph({
    groupID,
    startDate,
    endDate,
    showEmail,
    showVoice,
    showText
}: NotificationsCountsGraphProps) {


    const [chartOptions, setChartOptions] = useState<GraphOptions | undefined>();
    const [userState] = useUserContext();
    const { t } = useTranslation();

    const graphRef = useRef<GraphType>(undefined);

    const {data: group } = useQueryNotifications(useGroup)({
        customerID: userState.customer?.id as number,
        groupID
    });

    const {data, status } = useQueryNotifications(useAlarmNotificationCounts)({
        organizationID: group?.organizationID ?? -1,
        contextGroupID: groupID,
        //queryParams: {
            startDate,
            endDate,
        //    filterToGroup: true
        //}
    });

    useEffect(() => {

        if (data) {

            const days = differenceInDays(endDate, startDate);
            const chartData = NotificationsCountsGraphUtils.getChartOptions(
                            days,
                            data, 
                            showText,
                            showEmail, 
                            showVoice);

            setChartOptions({ 
                optionItems: [chartData] 
            });
        }
    }, [
        data, 
        startDate,
        endDate,
        setChartOptions,
        showText,
        showEmail,
        showVoice,
    ]);


    // this effect should run on every render to ensure the chart fills the view
    useEffect(() => {
        // must give time for the sidesheet transition to close has completed
        setTimeout(() => {
            graphRef.current?.reflow();
        }, 500);
    });

    return (

        <DashboardContainer 
            dashboardContainerType={DashboardContainerType.Graph}
            title={t('alarmDashboard.notificationsByTypes')}
            loading={status === 'loading'}
            >

            {(data?.length ?? 0) === 0 ?
                <NoData text={t('alarmDashboard.noData')} />
                :
                chartOptions && 
                <Graph ref={graphRef} options={chartOptions} />
            }

        </DashboardContainer>
    );
}
